'use client';

import React, { useEffect, useRef } from 'react';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import { PAGE_BREAKPOINTS } from 'constants/common';
import AssociatedDealerModalContent from './components/associated-dealer-modal/associated-dealer-modal-content';
import { AssociatedDealerDrawerContent } from './components/associated-dealer-drawer/associated-dealer-drawer-content';
import { DealerResponse } from 'services/dealer';
import { DealerAssociationResponse } from 'services/dealer-association';
import { DealerErrorResponse } from 'services/dealer-association/types';
import { LocationAddress } from 'services/location/types';
interface AssociatedDealerMainWrapperProps {
  isLoggedIn: boolean;
  isDealerUser: boolean;
  isInstantAccessUser: boolean;
  isCspUser: boolean;
  dealerUserResponse: DealerResponse;
  registeredUserResponse: DealerAssociationResponse | DealerErrorResponse;
  storeName: string;
  storeAddress: LocationAddress;
  openAdpModal: boolean;
  showSkipThisStep: boolean;
  isStoreLocationTandCFlag?: boolean;
  entitlementResponse?: {
    redirectURL: string;
    isMicoCookieRequired: boolean;
  };
  isStoreLocationListViewUpdateFlag?: boolean;
  isAssociatedDealerModalFlag?: boolean;
  isStoreLocationMapViewUpdateFlag?: boolean;
  isPCCAssociatedDealerFFEnabled?: boolean;
  isStoreLocationPinEnhancementFlag?: boolean;
  isLoginADP?: boolean;
  isfullMapViewMobileFlagEnabled?: boolean;
  isStoreLocationOptimizationFlag?: boolean;
  restrictedDealerStores?: string[];
}

const AssociatedDealerContainer = (props: AssociatedDealerMainWrapperProps) => {
  const {
    entitlementResponse,
    isAssociatedDealerModalFlag = false,
    isDealerUser
  } = props;
  const isRedirecting = useRef(false);
  const { onSuccessHandler } = useAssociatedDealer();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  useEffect(() => {
    if (entitlementResponse?.redirectURL && !isRedirecting.current) {
      onSuccessHandler(entitlementResponse);
      isRedirecting.current = true;
    }
  }, [entitlementResponse, onSuccessHandler]);

  if (isMD === undefined) return null;

  return (
    <Conditional test={!entitlementResponse?.redirectURL}>
      <Conditional
        test={isAssociatedDealerModalFlag && !isMD && !isDealerUser}
        fallback={<AssociatedDealerModalContent {...props} />}
      >
        <AssociatedDealerDrawerContent isMobileDrawerActive {...props} />
      </Conditional>
    </Conditional>
  );
};

export default AssociatedDealerContainer;
